import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Servicios
import { getUsuarios, saveUsuario, deleteUsuario } from '../../../services/UserService';

// Estilos
import '../../static/Global.css';
import '../../static/Home.css';
import '../../static/Aside.css';
import '../../static/Flotante.css';

function DashboardUsuarios() {
    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [nuevaContrasena, setNuevaContrasena] = useState('');
    const [verContrasena, setVerContrasena] = useState(false);

    // 1. Añadimos 'nombre' al estado inicial
    const [formData, setFormData] = useState({
        id: '',
        nombre: '', // <--- Nuevo
        email: '',
        contrasena: '',
        rol: 'EMPLEADO'
    });

    useEffect(() => { cargarLista(); }, []);

    const cargarLista = async () => {
        try {
            const data = await getUsuarios();
            setUsuarios(data);
            setLoading(false);
        } catch (error) {
            alert("Error: " + error.message);
        }
    };

    const openModal = (user = null) => {
        if (user) {
            setFormData({
                id: user.id,
                nombre: user.nombre || '', // <--- Mapear nombre
                email: user.email,
                contrasena: '',
                rol: user.rol
            });
        } else {
            setFormData({ id: '', nombre: '', email: '', contrasena: '', rol: 'EMPLEADO' });
        }
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setNuevaContrasena('');
        setIsModalOpen(false);
    };

    const handleSave = async (e) => {
        e.preventDefault();

        try {
            await saveUsuario({
                ...formData,
                contrasena: nuevaContrasena
            });

            alert("Operación exitosa");
            closeModal();
            cargarLista();

        } catch (error) {
            alert("Error al guardar: " + error.message);
        }
    };

    const handleDelete = async (id) => {
    if (window.confirm("¿Estás seguro de eliminar este usuario?")) {
        try {
            // Llamamos al servicio
            const resultado = await deleteUsuario(id);
            
            // Si no hubo error, mostramos el mensaje de confirmación
            alert("¡Eliminado! El usuario ha sido removido con éxito."); 
            
            // Recargamos la lista para ver los cambios
            cargarLista();
        } catch (error) {
            console.error(error);
            alert("Error al eliminar: " + error.message);
        }
    }
};

    return (
        <section className="main__content">
            <div className="table-container">
                <div className="table-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <h2>LISTADO DE USUARIOS</h2>
                    <button type="button" className="btn-vender-sidebar" onClick={() => openModal()}>
                        <i className="fa fa-plus"></i> Nuevo Usuario
                    </button>
                </div>

                <div className="table-responsive">
                    <table className="novatech-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Nombre</th> 
                                <th>Email</th>
                                <th>Rol</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                            <tbody>
                            {loading ? (
                                <tr>
                                <td colSpan="5">Cargando...</td>
                                </tr>
                            ) : (
                                usuarios.map((u) => (
                                <tr key={u.id}>
                                    <td>{u.id}</td>
                                    <td><strong>{u.nombre}</strong></td>
                                    <td>{u.email}</td>
                                    <td>
                                    <span className={`badge-${u.rol.toLowerCase()}`}>
                                        {u.rol}
                                    </span>
                                    </td>
                                    <td className="actions-cell">
                                    <button className="btn-edit" onClick={() => openModal(u)}>
                                        <i className="fa fa-edit"></i>
                                    </button>
                                    <button className="btn-delete" onClick={() => handleDelete(u.id)}>
                                        <i className="fa fa-trash"></i>
                                    </button>
                                    </td>
                                </tr>
                                ))
                            )}
                            </tbody>
                    </table>
                </div>
            </div>

            {isModalOpen && (
                <div className="modal" style={{ display: 'flex' }}>
                    <div className="modal-content">
                        <form onSubmit={handleSave}>
                            <h2>{formData.id ? "EDITAR USUARIO" : "NUEVO USUARIO"}</h2>
                            
                            {/* NUEVO CAMPO NOMBRE */}
                            <div className="form-group">
                                <label>Nombre Completo:</label>
                                <input 
                                    type="text" 
                                    value={formData.nombre} 
                                    required
                                    placeholder="Ej: Juan Perez"
                                    onChange={(e) => setFormData({ ...formData, nombre: e.target.value })} 
                                />
                            </div>

                            <div className="form-group">
                                <label>Email:</label>
                                <input 
                                    type="email" 
                                    value={formData.email} 
                                    required
                                    onChange={(e) => setFormData({ ...formData, email: e.target.value })} 
                                />
                            </div>

                            <div className="form-group">
                                <label>Contraseña:</label>
                                <div className="password-wrapper" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                    <input 
                                        type={verContrasena ? "text" : "password"} 
                                        placeholder={formData.id ? "Dejar en blanco para no cambiar" : "Mínimo 6 caracteres"}
                                        value={nuevaContrasena} // 👈 Ahora usa el estado local limpio
                                        required={!formData.id} // Obligatorio solo si es un usuario nuevo
                                        onChange={(e) => setNuevaContrasena(e.target.value)} // 👈 Actualiza el estado local
                                        style={{ width: '100%', paddingRight: '40px' }} 
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setVerContrasena(!verContrasena)}
                                        style={{
                                            position: 'absolute',
                                            right: '12px',
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer',
                                            color: '#888',
                                            padding: '0',
                                            display: 'flex',
                                            alignItems: 'center',
                                            height: '100%'
                                        }}
                                    >
                                        <i className={verContrasena ? "fa-solid fa-eye-slash" : "fa-solid fa-eye"} style={{ fontSize: '16px' }}></i>
                                    </button>
                                </div>
                            </div>

                            <div className="form-group">
                                <label>Rol del Usuario:</label>
                                <select 
                                    value={formData.rol}
                                    onChange={(e) => setFormData({ ...formData, rol: e.target.value })}
                                >
                                    <option value="ADMINISTRADOR">ADMINISTRADOR</option>
                                    <option value="EMPLEADO">EMPLEADO</option>
                                </select>
                            </div>

                            <div className="actions">
                                <button type="submit" className="btn-save">Guardar Cambios</button>
                                <button type="button" className="btn-cancel" onClick={closeModal}>Cancelar</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </section>
    );
}

export default DashboardUsuarios;